module.exports = __webpack_public_path__ + "img/BrandMe_IA_MuseoArte_4.6273eb63.png";